import React, { useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import Icon from '../../components/tables/Icon';
import axios from 'axios';
import { DateTime } from 'luxon';
import language from '../../variables/language';
import { useDraggable } from '@dnd-kit/core';
import IconChangeStage from '../../components/icons/IconChangeStage';
export default function PipeCard(props) {
   const navigate = useNavigate();
   const [displayStages , setDisplayStages ] = useState('none');
   const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
      id: props.id,
      data: { clientId: props.id, fromStageId: props.stageId, client: props.client, color: props.color },
   });

   const oncliHundler =(e)=> {
      props.stateHundler('menu',props.id, props.client);
   }
   const changeStage = (e) => {
      e.stopPropagation();
      if(displayStages==='none'){
         setDisplayStages('flex');
      }else{
         setDisplayStages('none');
      }

   }


   const setStage = (e,id) => {
      e.stopPropagation();
      setDisplayStages('none');

      axios.put('/api/clients/'+props.id,
         JSON.stringify({stage:id}), {
            withCredentials: true,
            headers: {
               'Content-Type': 'application/json',
            },
      }).then(response => {
        props.onRefresh();
      })
      .catch(err => {
      if(err.response && err.response.status === 401 ){
         navigate('/login');
      }
      console.log(err);
      });
   }
   const formatDateTime = (date) => {
     return  DateTime.fromISO(date.replace(/\[.*\]/, ""), { setZone: true }).toFormat("dd.MM.yyyy HH:mm");
   }
   const style = {
      borderLeft:`0px solid ${props.color}`,
      borderRight:`0px solid ${props.color}`,
      opacity: (isDragging || props.pending) ? 0.25 : 1,
   };
  return (
    <div className='pipe-card' ref={setNodeRef} {...listeners} {...attributes} onClick={oncliHundler}  style={style} >
      <div style={{display:'block'}}>
         <h4 className='pipe-card-title' >{props.title}</h4>
         {props.price ?
            <div className='card-parameter'>
                  <p className='pipe-card-hint'>{language[language.lang].price}:</p> <p className='pipe-card-price'>{props.price}</p></div> : ('') }
         {props.product && props.product != 'None' ?
            <div className='card-parameter'>
                  <p className='pipe-card-hint'>Product:</p> <p  className='pipe-card-value'>{props.product}</p></div> : ('') }
         {props.source && props.source.name ?
            <div className='card-parameter'>
                  <p className='pipe-card-hint'>Source:</p><p  className='pipe-card-value'>{props.source.name }</p>
            </div> : ('')
          }
         {props.category && props.category.name ?
            <div className='card-parameter'>
               <p className='pipe-card-hint'>Category:</p> <p  className='pipe-card-value'>{props.category.name }</p>
            </div> : ('')
         }

         {/* <div className='pipe-card-line'>
            <div className='pipe-card-line-inner'  style={{ width:`${props.probability}%` }}></div>
         </div> */}
         <p  className='pipe-card-secondary'>{formatDateTime(props.dAdd)}</p>
      </div>
      <div className='card-stage-btn' onClick={changeStage} title={language[language.lang]['stage']}>
         <IconChangeStage style={{width:12,height:12,margin:0,fill:'var(--lighttext-color)'}} />
      </div>
      <div className='card-pipe-selector' style={{display:displayStages}} onClick={(e) => e.stopPropagation()}>
         {Array.isArray(props.stages) ? (
                  props.stages.filter(item => item.id !== props.stageId).map(item => (
                     <div key={item.id+'sd'} onClick={ (e) => setStage(e, item.id) } style={{borderLeft:`3px solid ${item.color}`,boxShadow:` 0px 0px 3px ${item.color}`}} className='card-selector-stage txt-c' >{item.name}</div>
                  ))
               ) : (
                  <div>{language[language.lang]['Empty list']}</div>
            )}
      </div>
    </div>
  )
}
